// src/utils/conferenceColors.js

const COLORS = [
	'#6C5CE7', // Фиолетовый
	'#00B894', // Зелёный
	'#E17055', // Оранжевый
	'#0984E3', // Синий
	'#FDCB6E', // Жёлтый
	'#E84393', // Розовый
	'#00CEC9', // Бирюзовый
	'#FF7675', // Красный
	'#74B9FF', // Голубой
	'#A29BFE', // Лавандовый
]

/**
 * Получить стабильный цвет по courseId
 * @param {string|number} courseId
 * @param {number} fallbackIndex - индекс для fallback
 * @returns {string} HEX цвет
 */
export function getCourseColor(courseId, fallbackIndex = 0) {
	if (courseId != null) {
		const hash = String(courseId)
			.split('')
			.reduce((acc, char) => acc + char.charCodeAt(0), 0)
		return COLORS[hash % COLORS.length]
	}
	return COLORS[fallbackIndex % COLORS.length]
}

/**
 * Нормализация ID к числу для сравнения
 * @param {string|number} id
 * @returns {number}
 */
export function normalizeId(id) {
	if (id == null) return null
	const num = Number(id)
	return Number.isNaN(num) ? null : num
}

export { COLORS }
